import { Button, Icons, Typography } from '@healthinal/ui';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { getGetAppointmentsForPatientWithoutLabOrderQueryKey } from '../../../api/generated/appointment-controller/appointment-controller.ts';
import {
  getGetLabOrderByAppointmentIdQueryKey,
  getGetLabOrdersByPatientQueryKey,
  useDeleteLabOrderById,
} from '../../../api/generated/lab-order-controller/lab-order-controller.ts';
import { LabOrderDtoType } from '../../../api/generated/model';
import { getLabOrderTypeName } from '../../../utils/labOrder.ts';
import { DeleteConfirmationDialog } from '../DeleteConfirmationDialog.tsx';

export function DeleteLabOrderButton({
  orderId,
  patientId,
  appointmentId,
  orderType,
}: {
  orderId: string;
  patientId: string;
  appointmentId: string | undefined | null;
  orderType: LabOrderDtoType;
}) {
  const queryClient = useQueryClient();
  const [isDeleteLabOrderConfirmationDialogOpen, setIsDeleteLabOrderConfirmationDialogOpen] = useState(false);

  const deleteLabOrderMutation = useDeleteLabOrderById({
    mutation: {
      onSuccess: () => {
        toast.success('Test wurde erfolgreich gelöscht');
        void queryClient.invalidateQueries({ queryKey: getGetLabOrdersByPatientQueryKey(patientId) });
        void queryClient.invalidateQueries({
          queryKey: getGetLabOrderByAppointmentIdQueryKey(appointmentId ?? ''),
        });
        void queryClient.invalidateQueries({
          queryKey: getGetAppointmentsForPatientWithoutLabOrderQueryKey(patientId),
        });
      },
      onError: () => {
        toast.error('Beim Löschen des Tests ist ein Fehler aufgetreten');
      },
    },
  });

  return (
    <>
      <Button
        color={'danger'}
        endDecorator={<Icons.Delete />}
        loading={deleteLabOrderMutation.isPending}
        onClick={() => setIsDeleteLabOrderConfirmationDialogOpen(true)}>
        Löschen
      </Button>
      <DeleteConfirmationDialog
        open={isDeleteLabOrderConfirmationDialogOpen}
        onCancel={() => setIsDeleteLabOrderConfirmationDialogOpen(false)}
        onDelete={() => {
          deleteLabOrderMutation.mutate({ id: orderId });
          setIsDeleteLabOrderConfirmationDialogOpen(false);
        }}
        modalTitle={'Test löschen'}>
        <Typography>Ausgewählten {getLabOrderTypeName(orderType)} Test wirklich löschen?</Typography>
      </DeleteConfirmationDialog>
    </>
  );
}
